import React from 'react';
interface FeatureBadgeProps {
  icon?: React.ReactNode;
  label: string;
  value?: string;
  compact?: boolean;
}
export function FeatureBadge({
  icon,
  label,
  value,
  compact
}: FeatureBadgeProps) {
  if (compact) {
    return <div className="flex flex-col items-center justify-center p-2.5 rounded-lg bg-[#c4d4c0] text-[#2d4a3a] text-center min-h-[75px] w-[85px] shadow-md" data-id="element-106">
        {icon && <div className="mb-1.5" data-id="element-107">{icon}</div>}
        {value && <div className="text-base font-bold mb-0.5" data-id="element-108">{value}</div>}
        <div className="text-[9px] leading-tight font-semibold" data-id="element-109">{label}</div>
      </div>;
  }
  return <div className="flex flex-col items-center justify-center p-4 rounded-xl bg-[#c4d4c0] text-[#2d4a3a] text-center min-h-[120px] w-[110px] shadow-md" data-id="element-110">
      {icon && <div className="mb-2" data-id="element-111">{icon}</div>}
      {value && <div className="text-2xl font-bold mb-1" data-id="element-112">{value}</div>}
      <div className="text-xs leading-tight font-semibold" data-id="element-113">{label}</div>
    </div>;
}